export const REQUIRES_ACTION = 'requires_action';
export const SUCCEEDED = 'succeeded';
